import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { BannerComponent, IconComponent } from '@mode/capra';
import { CalendlyPopupButtonComponent } from '@mode/shared/ui';
import { StatusIconComponent } from '@mode/capra';
import { getAppName } from '@mode/shared/util-js';

enum BannerType {
  None = '',
  Warning = 'warning',
  Danger = 'danger',
}

@Component({
  standalone: true,
  selector: 'mode-data-usage-banner',
  imports: [BannerComponent, IconComponent, CommonModule, CalendlyPopupButtonComponent, StatusIconComponent],
  templateUrl: './data-usage-banner.component.html',
  styleUrls: ['./data-usage-banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DataUsageBannerComponent implements OnInit {
  readonly appName = getAppName();
  public bannerText?: string;
  public bannerIcon?: string;
  public bannerType: BannerType = BannerType.None;
  public BannerType = BannerType;

  @Input() dataUsage?: number = 0;

  ngOnInit() {
    this.dataUsage ||= 0;
    this.bannerType =
      (this.dataUsage > 99 && BannerType.Danger) || (this.dataUsage > 79 && BannerType.Warning) || BannerType.None;
    this.bannerText =
      this.bannerType === BannerType.Danger
        ? "You've hit 100% data compute usage"
        : 'Your data compute usage is approaching 100%';
    this.bannerIcon = this.bannerType === BannerType.Danger ? 'prohibited' : 'warning';
  }
}
